// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const PrivateRoute = ({ element }) => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/" replace />; // Ensure `replace` is used to avoid navigating back to private route
  }

  return element;
};

export default PrivateRoute;
